import React from "react";
import { Button, Modal, Table } from "react-bootstrap";

function ViewPoMedicine({ show, onHide, poListDataById, setPoListDataById }) {
  const items =
    poListDataById && poListDataById.items ? poListDataById.items : [];
  const leadTime =
    poListDataById && poListDataById.lead_time_days
      ? Number(poListDataById.lead_time_days)
      : 0;

  const leadTimeBuffer =
    poListDataById && poListDataById.lead_time_days_buffer
      ? Number(poListDataById.lead_time_days_buffer)
      : 0;

  const totalLeadTime = leadTime + leadTimeBuffer;
  return (
    <Modal
      show={show}
      onHide={onHide}
      bsSize="lg"
      backdrop="static"
      dialogClassName="po-modal-70"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Medicine Details - Delivery Within {totalLeadTime} Days
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table>
          <thead>
            <tr>
              <th>Invoice Number</th>
              <th>Medicine Name</th>
              <th>Supplier Name</th>
              <th>Supplier Mobile Number</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>discount</th>
              <th>amount</th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 ? (
              items.map((item, index) => (
                <tr key={index}>
                  <td>{poListDataById.invoice_no}</td>
                  <td>
                    {item.name} - ({item.item_code || "-"})
                  </td>
                  <td>{poListDataById.supplier_name}</td>
                  <td>{poListDataById.supplier_mobile}</td>
                  <td>{item.quantity}</td>
                  <td>{item.price}</td>
                  <td>{item.discount}</td>
                 <td>{Number(item.amount).toFixed(2)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-danger" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ViewPoMedicine;
